// extracted by mini-css-extract-plugin
export var formContainer = "_jm-0";
export var message = "_jm-1";